import { WixDesignSystemProvider } from '@wix/design-system';
import { PremiumLocaleProvider, } from '@wix/premium-react-text';
import React from 'react';
import { BreakpointProvider } from './BreakpointProvider';
import { ComponentsTranslationsProvider } from './ComponentsTranslationsProvider';
export const PackagePickerComponentsProvider = ({ children, localeProps, translationProps: { Trans, i18n }, }) => {
    return (React.createElement(ComponentsTranslationsProvider, { Trans: Trans, i18n: i18n },
        React.createElement(BreakpointProvider, null,
            React.createElement(PremiumLocaleProvider, { ...localeProps },
                React.createElement(WixDesignSystemProvider, { features: { newColorsBranding: true } }, children)))));
};
//# sourceMappingURL=PackagePickerComponentsProvider.js.map